import { history, IRouteComponentProps, useDispatch, useModel } from 'umi';
import {
  ComponentWrapper,
  Feedback,
  MediaContextProvider,
  NavigationFooter,
  NavigationHeader,
} from '@digit-fe/digit-component';
import { useEffect, useRef, useState } from 'react';
import { ConfigProvider, message } from 'antd';
import cx from 'classnames';
import { delCookie, loginCas } from '@/utils/index';
import styles from './index.less';
import zhCN from 'antd/locale/zh_CN';

export default function BaseLayout(props: IRouteComponentProps) {
  const { children } = props;
  const pathName = window.location.pathname;
  const dispatch = useDispatch();
  const { initialState } = useModel('@@initialState');
  const ref = useRef<any>();
  const [activeType, setActiveType] = useState<'firstActive' | 'serviceActive' | undefined>();
  const initialStateRef = useRef(initialState);

  useEffect(() => {
    if (initialState) {
      dispatch({
        type: 'userInfo/save',
        payload: initialState,
      });
      initialStateRef.current = initialState;
    }
  }, [initialState]);

  return (
    <MediaContextProvider>
      <div style={{ height: '48px', zIndex: '2' }}>
        <NavigationHeader
          navItem={[
            {
              label: '首页',
              href: `${process.env.HOME_URL}`,
              isActive: false,
            },
            {
              label: 'AI专题',
              href: `${process.env.HOME_URL}/topic/ai`,
              isActive: false,
            },
            {
              label: '服务平台',
              href: `${process.env.SERVICE_URL}`,
              isActive: false,
            },
            {
              label: '文档',
              href: `${process.env.HELP_URL}`,
              isActive: false,
            },
            {
              label: '学院',
              href: `${process.env.EDU_URL}`,
              isActive: false,
            },
            {
              label: '问答',
              href: `${process.env.BBS_URL}/wenda`,
              isActive: false,
            },
            {
              label: '论坛',
              href: `${process.env.BBS_URL}/topic`,
              isActive: false,
            },
            {
              label: '认证',
              href: `${process.env.CERT_URL}`,
              isActive: false,
            },
            {
              label: '招聘',
              href: `${process.env.BBS_URL}/jobs`,
              isActive: false,
            },
            {
              label: '市场',
              href: `${process.env.MARKET_URL}`,
              isActive: false,
            },
          ]}
          className={cx(
            styles.layout,
            activeType === 'serviceActive' && styles.service_active,
            activeType === 'firstActive' && styles.index_active,
          )}
          ref={ref}
          env={process.env.UMI_ENV === 'product' ? 'prod' : 'test'}
          menu={[
            {
              id: '0',
              title: '帆软社区',
              path: '/v2',
              onClick: () => {
                window.location.href = `${process.env.HOME_URL}`;
              },
            },
          ]}
          uid={initialState?.uid}
          username={initialState?.username}
          onMonitorChange={(data) => {
            console.log('监听到了通行证数据');
            console.log(data);
            if (!data?.uid) {
              delCookie('fr_token');
              message.success('您已成功退出登录');
              window.location.href = `${process.env.ID_URL}/login/token/logout?referrer=${window.location.href}`;
            } else {
              if (process.env.UMI_ENV !== 'dev') {
                if (!initialStateRef?.current?.uid) {
                  loginCas({
                    env: process.env.UMI_ENV === 'product' ? 'prod' : 'test',
                  });
                }
              }
            }
          }}
          onLogoClick={() => {
            history.push('/');
          }}
          onLogin={() => {
            loginCas({
              env: process.env.UMI_ENV === 'product' ? 'prod' : 'test',
            });
          }}
          onLogout={() => {
            delCookie('fr_token');
            message.success('您已成功退出登录');
            window.location.href = `${process.env.ID_URL}/login/token/logout?referrer=${window.location.href}`;
          }}
          onMenuClick={(data) => {
            console.log(data);
            history.push(data.path);
            ref.current?.closeModal();
          }}
        />
      </div>

      <div className={styles.page}>
        <ConfigProvider locale={zhCN}>{children}</ConfigProvider>
        <ComponentWrapper>
          <Feedback
            onDataChange={(isFiners, uid, token, mobile) => {
              const tempMobile = mobile || '';
              if (isFiners) {
                return `https://pe9qbh7c.shuzhiniao.com/web/#/h5/business/brd?embedded=true&modal=true&hideRootMenu=true&spaceId=11093&%E7%B1%BB%E5%9E%8B=37047&%E5%8F%8D%E9%A6%88%E4%BA%BAUID=${uid}&%E9%A1%B5%E9%9D%A2URL=${encodeURIComponent(
                  window.location.href,
                )}&%E5%8F%8D%E9%A6%88%E4%BA%BA%E6%89%8B%E6%9C%BA%E5%8F%B7=${tempMobile}&hiddenFields=%E9%A1%B5%E9%9D%A2URL%2C%E5%8F%8D%E9%A6%88%E4%BA%BAUID%2C%E7%B1%BB%E5%9E%8B%2C%E5%A4%84%E7%90%86%E4%BA%BA%E5%9B%9E%E5%A4%8D%2C%E5%8F%8D%E9%A6%88%E4%BA%BA%E6%89%8B%E6%9C%BA%E5%8F%B7%2C%E6%A8%A1%E5%9D%97`;
              }
              return `https://pe9qbh7c.shuzhiniao.com/web/#/ticket/a2555f84970f418a98960adb4029aed1/form?embedded=true&hiddenFields=%E9%A1%B5%E9%9D%A2URL%2C%E5%8F%8D%E9%A6%88%E4%BA%BAUID%2C%E5%A4%84%E7%90%86%E4%BA%BA%E5%9B%9E%E5%A4%8D&ticketToken=${token}`;
            }}
            uid={initialState?.uid}
            env={process.env.UMI_ENV === 'product' ? 'prod' : 'test'}
          />
        </ComponentWrapper>
        <NavigationFooter />
      </div>
    </MediaContextProvider>
  );
}
